// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_notifications_1hmm4_9ut38_9:not(#\\9),.awsui_notifications-sticky_1hmm4_9ut38_10:not(#\\9){z-index:850}.awsui_notifications_1hmm4_9ut38_9:not(#\\9){position:relative}.awsui_notifications-sticky_1hmm4_9ut38_10:not(#\\9){inset-block-start:0;position:sticky;--awsui-flashbar-sticky-bottom-margin-iof9y8: var(--space-xxl-pd3205, 32px)}.awsui_no-content-paddings_1hmm4_9ut38_25:not(#\\9){--awsui-stacked-notifications-bottom-margin-iof9y8: var(--space-scaled-l-08jb88, 20px)}\n", ""]);
// Exports
module.exports = exports;
